<template>
<div>
  <b-button size="sm" variant="primary" @click="clearCache">Clear Cache</b-button>
</div>
</template>

<script>
import http from '@/mixins/http';
import notification from "@/mixins/notification";
export default {
  name: "CacheManagement",
  mixins: [http, notification],
  methods: {
    clearCache() {
      this.axios.post('/admin/api/appCache').then(() => {
        this.PromptSuccess('Success', 'Cache had been cleared.')
      })
    }
  }
}
</script>

<style scoped>

</style>